import React from 'react';

import s from './Quote.scss';

interface IProps {
  quote: React.ReactElement<any> | string;
  citation?: React.ReactElement<any>;
  isColumnLayout?: boolean;
}

export const Quote = ({ quote, citation, isColumnLayout }: IProps) => {

  if (!quote) {
    return null;
  }

  return (
    <div className={s('quote', { offset: !isColumnLayout })}>
      <div className={s.quote__inner}>
        <blockquote className={s.quote__quote}>
          {quote}
          {citation && (
            <footer className={s.quote__citation}><cite>{citation}</cite></footer>
          )}
        </blockquote>
      </div>
    </div>
  );
};
